export default function TVAConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('tva');
}

TVAConfiguration.$inject = ['$translatePartialLoaderProvider'];
